import { ThumbDown } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useConfirmationDialog } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { MessageForm } from '../MessageForm/MessageForm';
import { I18nNamespace } from '~/common/types';

export interface DeclineButtonProps {
  loading?: boolean;
  disabled?: boolean;
  onSubmit: (data: { message: Union.Nullable<string> }) => Promise<void>;
}

export const DeclineButton = ({ loading, disabled, onSubmit }: DeclineButtonProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiatedQuoteWidget' });
  const { confirm } = useConfirmationDialog();

  return (
    <Button
      loading={loading}
      disabled={disabled}
      loadingPosition="start"
      startIcon={<ThumbDown />}
      variant="contained"
      color="error"
      onClick={confirm(onSubmit, {
        title: t('declineDialog.title'),
        maxWidth: 'md',
        content: <MessageForm i18nKeyPrefix={'NegotiatedQuoteWidget.declineDialog'} />,
        confirm: {
          children: t('declineDialog.apply'),
          color: 'primary',
        },
        cancel: {
          children: t('declineDialog.cancel'),
        },
      })}
    >
      {t('declineButton')}
    </Button>
  );
};
